import React, { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

const KEY = "scent_royale_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const lineId = (i) => `${i.product_id}-${i.volume || ""}-${i.engraving || ""}`;

  const addItem = (item) => {
    setItems((prev) => {
      const id = lineId(item);
      const existing = prev.find((p) => lineId(p) === id);
      if (existing) {
        return prev.map((p) => (lineId(p) === id ? { ...p, quantity: p.quantity + item.quantity } : p));
      }
      return [...prev, item];
    });
    toast.success(`${item.name} added to your bag`);
    setOpen(true);
  };

  const removeItem = (id) => setItems((prev) => prev.filter((p) => lineId(p) !== id));
  const updateQty = (id, qty) =>
    setItems((prev) => prev.map((p) => (lineId(p) === id ? { ...p, quantity: Math.max(1, qty) } : p)));
  const clear = () => setItems([]);

  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const afUnits = items.filter((i) => i.subcategory === "Air Fresheners").flatMap((i) => Array(i.quantity).fill(i.price)).sort((a, b) => b - a);
  let discount = 0;
  for (let k = 0; k + 3 <= afUnits.length; k += 3) discount += Math.max(0, afUnits[k] + afUnits[k + 1] + afUnits[k + 2] - 25);
  const afCount = afUnits.length;
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartContext.Provider
      value={{ items, addItem, removeItem, updateQty, clear, subtotal, discount, afCount, count, open, setOpen, lineId }}>
      {children}
    </CartContext.Provider>
  );
}
